import * as React from "react";
import {useMemo, useState} from "react";
import {
    Bookmark,
    Delivery,
    DeliveryState,
    ReasonForReturnEnum,
    Recipient,
    ReturnDeliveryConfig,
    TenantUser
} from "./types";
import {StorageFlow} from "./StorageFlow";
import {ReturnDeliveryDialog} from "./ReturnDeliveryDialog";
import {AuthorizeUserDialog} from "./AuthorizeUserDialog"; 
import { v4 as uuidv4 } from 'uuid';

interface BookmarkFlowProps {
    delivery: Delivery;
    bookmark: Bookmark;
    user?: TenantUser;
    onDone: ()=> void;
}

export function BookmarkFlow({delivery, bookmark, onDone}: BookmarkFlowProps) {
    const [returnDialogDone, setReturnDialogDone] = useState(false);
    const [authorizedRecipient, setAuthorizedRecipient] = useState<Recipient>();

	const config = useMemo((): ReturnDeliveryConfig => {
		return {
			enabled: true,
			returnRequiresAuthorization: bookmark.requireAuthorization ?? false,
			parameters: {
				additionalInformation: {
					enabled: true,
					mandatory: bookmark.requireDescription ?? false,
					verification: false
				}
			}
		}
	}, [bookmark])

    function needsDescription() {
        return bookmark?.requireDescription;
    }

    if (!needsDescription()) {
        buildDelivery();
    }

    function buildDelivery() {
        if (bookmark)  {
            if (!delivery) {
                delivery = {
                    recipients: bookmark.recipients,
                    storage: {},
                    delivery: {
                        deliveryId: uuidv4(),
                        isCreatedOnCube: true,
                        state: DeliveryState.Stored
                    }
                }
            }

            if (bookmark.requireAuthorization) {
                if (authorizedRecipient && delivery) {
                    delivery.sender = {
                        ...authorizedRecipient,
                        name: authorizedRecipient.recipientName
                    }
                }
            }

        }
    }
    function handleOnReturnDialogSubmit(deliveryNoteId: string, reasonForReturn: ReasonForReturnEnum | undefined, email: string, phone: string, customerId: string, positionNumbers: string, addInfo: string) {
        buildDelivery();
        if (delivery) {
            delivery.returnDelivery = {description : addInfo, state: DeliveryState.Stored};
        }
        setReturnDialogDone(true);
    }

    async function handleOnReturnDialogBack() {
        setReturnDialogDone(false);
        onDone();
    }

    async function handleOnAuthorizeUserDialogCancel() {
        onDone();
    }

    async function handleOnAuthorizeUserDialogSubmit(recipient: Recipient|undefined) {
        if (recipient) {
            setAuthorizedRecipient(recipient);
        } else {
            setAuthorizedRecipient(undefined);
        }
    }

    if (bookmark && bookmark.requireAuthorization && !authorizedRecipient) {
        return (
            <AuthorizeUserDialog
                authorizationProviderHint={bookmark.authorizationProviderHint}
                onBack={handleOnAuthorizeUserDialogCancel}
                onSubmit={handleOnAuthorizeUserDialogSubmit}
            />
        );
    }


    if (delivery && (returnDialogDone || !needsDescription())) {
        return (
            <StorageFlow
                disableAddToBox
                delivery={delivery}
                onDone={onDone}
            />);
    }

    return (
        <ReturnDeliveryDialog
			label={bookmark.label}
            config={config}
            delivery={delivery}
            onBack={handleOnReturnDialogBack}
            onSubmit={handleOnReturnDialogSubmit}
        />
    );
} 
